import React, { useEffect, useState } from 'react'
import Header from '../adminComponents/header/Header';
import { Box, Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useMediaQueries } from '../usecontext/UseProvider';
import { getSomethingUnique } from '../services/SomethingUnique';

const SomethingUnique = () => {
  const { isSmallScreen, setLoading } = useMediaQueries();
  const [somethingUnique, setSomethingUnique] = useState([]);

  const getSomethingUniqueData = async () => {
    try {
      setLoading(true);
      const response = await getSomethingUnique();
      setSomethingUnique(response.categoryItemDataSomethingUnique);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getSomethingUniqueData();
  }, []);

  return (
    <>
      <Header title="Something Unique" />
      <Box sx={{ pt: 3 }}>
        <Grid container spacing={isSmallScreen ? 0 : 3}>
          {somethingUnique?.map((item, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card
                sx={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                }}
              >
                <CardMedia
                  component="img"
                  image={item?.images[0]?.url}
                  alt={item?.name}
                  sx={{ borderRadius: '50%', height: '250px', maxWidth: '250px' }}
                />
                <CardContent sx={{ textAlign: 'center' }}>
                  {item?.name}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ >
  )
}

export default SomethingUnique
